module.exports = __webpack_public_path__ + "media/images/dpd-6144d33a.svg";